"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdfExportMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class PdfExportMapper {
    toDomain(result) {
        return lodash_1.default.get(result, "data.pdfExport");
    }
}
exports.PdfExportMapper = PdfExportMapper;
